module.exports = __webpack_public_path__ + "static/outreach-34de0a9f56d6dddbcfbcb2c3937fec9a.jpg";